import { render } from "./README.md?vue&type=template&id=72f92a1d"
import script from "./README.md?vue&type=script&lang=js"
export * from "./README.md?vue&type=script&lang=js"
script.render = render

export default script